import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import { useNavigate } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importing toast styles

import moment from "moment";
import CutOffDateForm from "../Forms/CutOffDateForm";

export default function CutOffDate() {
  const { setUserAccess, role } = useUser();
  console.log("role", role);

  const [tableData, setTableData] = useState();
  const [rowId, setRowId] = useState();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [permissionMassage, setPermissionMassage] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleClose = () => {
    setShowModal(false);
    setRowId();
  };

  // Define columns with action column correctly structured
  const columns = [
    {
      key: "action",
      label: "Action",
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="action-buttons"
            style={{ display: "flex", gap: "10px" }}
          >
            <button
              className="edit-btn"
              onClick={() => {
                fetchDataUserAccess("edit", true, params, "");
              }}
            >
              <TbEdit size={18} />
            </button>
            <button
              className="delete-btn"
              onClick={() => fetchDataUserAccess("delete", true, params, "")}
            >
              <RiDeleteBin6Line size={18} />
            </button>
          </div>
        </div>
      ),
    },
    { key: "fy_id", label: "Financial Year", flex: 1 },
    { key: "title", label: "Title", flex: 1 },
    { key: "cutoff_date", label: "Cut Off Date", flex: 1 },
    { key: "intimation_date", label: "Intimation Date", flex: 1 },

  
  ];

  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        checkPermission(role, method, result.permission)
          ? showPopup
            ? method == "delete"
              ? (setOpen(true), setRowId(params.id))
              : params
              ? (setRowId(params.id), setShowModal(true))
              : (setRowId(null), setShowModal(true))
            : goToLink
            ? navigate(goToLink)
            : ""
          : setPermissionMassage(true);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };
  const fetchData = async () => {
    try {
      const result = await getData("/api/all-financial-year-cutoff-date");
      if (result.success) {
        setTableData(result.data);

        if (!checkPermission("Cutoffdate", "view", result.permission)) {
          setPermissionMassage(true);
          setTimeout(() => {
            navigate("/dashboard");
          }, 2000);
        }
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };
  const indexedRows =
    tableData?.length > 0 &&
    tableData?.map((data, index) => ({
      index: index + 1,
      id: data.id,
      fy_id: data?.fy_id,
      title: data?.title,
      cutoff_date: moment(data?.cutoff_date).format("MM/DD/YYYY"),
      intimation_date: moment(data?.intimation_date).format("MM/DD/YYYY"),
    }));
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="usa-prose">
      <TopHeading
        // heading="Cut Off Date"
        setShowModal={() => {
          fetchDataUserAccess("add", true, "", "");
        }}
        isHideBtn={true}
      />
      <CommonTable columns={columns} data={indexedRows || []} />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-financial-year-cutoff-date/${rowId}`}
          getApi={fetchData}
        />
      )}
      {showModal && (
      <CommonModal
        isOpen={showModal}
        onClose={handleClose}
        title={rowId ? "Edit Cut Off Date" : "Add Cut Off Date"}
      >
        <CutOffDateForm
          onClose={handleClose}
          id={rowId}
          fetchData={fetchData}
        />
      </CommonModal>
      )}
      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
    </div>
  );
}
